var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessagesSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.565,
    height: 22.924,
    viewBox: "0 0 30.565 22.924",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "envelope-solid",
    d: "M2.866,64a2.866,2.866,0,0,0-1.719,5.158L14.137,78.9a1.916,1.916,0,0,0,2.292,0l12.99-9.743A2.866,2.866,0,0,0,27.7,64ZM0,70.686V83.1a3.824,3.824,0,0,0,3.821,3.821H26.745A3.824,3.824,0,0,0,30.566,83.1V70.686l-12.99,9.743a3.815,3.815,0,0,1-4.585,0Z",
    transform: "translate(0 -64)",
    fill: "#154157"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagesSolid);
export default __webpack_public_path__ + "static/media/messages-solid.8a96e177b7bfdd85914726b659b1e73a.svg";
export { ForwardRef as ReactComponent };